import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { BsMoonStars, BsSun } from 'react-icons/bs';
import { ConnectedProps, connect } from 'react-redux';
import { changeColorTheme } from '../features/app/appSlice';
import { RootState } from '../store';

interface IThemeButtonProps extends PropsFromRedux, React.AllHTMLAttributes<HTMLDivElement> {}
const ThemeButton = ({ colorTheme, changeColorTheme }: IThemeButtonProps) => {
	const onThemeButtonClick = () => {
		changeColorTheme(isLightTheme ? 'dark' : 'light');
	};

	const isLightTheme = colorTheme === 'light';
	return (
		<NavDropdown.Item as="button" onClick={onThemeButtonClick}>
			{isLightTheme ? (
				<>
					<BsMoonStars className="me-1" />
					Темна тема
				</>
			) : (
				<>
					<BsSun className="me-1" />
					Світла тема
				</>
			)}
		</NavDropdown.Item>
	);
};

const mapState = (state: RootState) => ({
	colorTheme: state.app.colorTheme,
});

const mapDispatch = { changeColorTheme };

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ThemeButton);
